document.addEventListener('click', function (e) {
  const notifyLabel = e.target.closest('label.notify-me');
  const notifyTrigger = e.target.closest('.quick-add__modal_notify');
  const stockIndicatorText = notifyLabel?.querySelector('.stock-indicator')?.textContent?.trim() || 'Join Waitlist';

  let stockIndicatorTextHeading = notifyLabel?.querySelector('.stock-indicator')?.textContent?.trim() || '';

  if (stockIndicatorText === 'Notify Me') {
    stockIndicatorTextHeading = 'Join Waitlist';
  } else if (stockIndicatorText === 'Join Waitlist') {
    stockIndicatorTextHeading = 'Coming Soon';
  } else {
    stockIndicatorTextHeading = stockIndicatorTextHeading || 'Coming Soon';
  }

  if (!notifyLabel && !notifyTrigger) return;

  const triggerEl = notifyLabel || notifyTrigger;
  const inputEl = notifyLabel?.querySelector('input[type="radio"]');

  const clickedVariantId = notifyLabel && inputEl
    ? (
        inputEl.dataset.variantId ||          // ✅ FIRST priority — works on PDP & PLP
        notifyLabel.dataset.variantId ||      // fallback on label attribute
        inputEl.value ||                      // PLP fallback: value = real variant ID
        null
      )
    : null;

  const clearNotifySelection = () => {
    if (inputEl) {
      inputEl.checked = false;
    }
  };

  const quickAddModal = document.querySelector('.quick-add-modal-desktop.open');
  if (quickAddModal) {
    quickAddModal.classList.remove('open');
  } 

  if (document.getElementById('notify-modal')) return;

  const parent = triggerEl.closest('.quick-add-component, .product-card, variant-picker');
  const variantOptions = parent?.dataset.variants
    ? JSON.parse(parent.dataset.variants)
    : [];
  console.log('variantOptions:', variantOptions);

  const outOfStockVariants = variantOptions.filter(v => v.available === false);
  const variantHTML = outOfStockVariants.map(v => `
    <button type="button" class="size-box" data-variant-id="${v.id}"><span>${v.size}</span><span class="ntm-placeholder">${stockIndicatorText}</span></button>
  `).join('');

  const modal = document.createElement('div');
  modal.id = 'notify-modal';
  modal.innerHTML = `
    <div class="notify-modal">
      <div class="notify-drawer__content drawer__content">
        <div class="notify-header">
           ${stockIndicatorTextHeading}
          <button class="notify-close" aria-label="Close">✕</button>
        </div>
        <div class="notify-body">
          <div class="notify-set1">
            ${outOfStockVariants.length > 1 ? `
            <div class="quick-title">
              <span>SIZE</span>
            </div>
            <div class="size-grid">${variantHTML}</div>
            <div class="notify-divider"></div>
          ` : ''}
            <div class="back-in-stock-form">
              <label for="notify_email">Enter your email address and we will notify you when the item becomes available.</label>
              <input type="email" id="notify_email" placeholder="Email*" required/>

              <div class="notify-checkbox">
                <input type="checkbox" id="customer_accepts_marketing" name="accepts_marketing" checked />
                <label for="customer_accepts_marketing">I agree to subscribe to the mailing list to be the first to know about new collections.</label>
              </div>

              <div class="notify-section-divider"></div>

              <label for="notify_phone" class="notify-phone-label">Add SMS alerts (optional)</label>
              <div class="notify-phone-wrapper">
                <select id="notify_phone_country" class="notify-phone-country" aria-label="Country code">
                  <option value="+44">GB +44</option>
                  <option value="+1-us">US +1</option>
                  <option value="+1-ca">CA +1</option>
                  <option value="+33">FR +33</option>
                  <option value="+49">DE +49</option>
                  <option value="+39">IT +39</option>
                  <option value="+34">ES +34</option>
                  <option value="+31">NL +31</option>
                  <option value="+32">BE +32</option>
                  <option value="+41">CH +41</option>
                  <option value="+43">AT +43</option>
                  <option value="+45">DK +45</option>
                  <option value="+46">SE +46</option>
                  <option value="+47">NO +47</option>
                  <option value="+353">IE +353</option>
                  <option value="+351">PT +351</option>
                  <option value="+81">JP +81</option>
                  <option value="+852">HK +852</option>
                  <option value="+65">SG +65</option>
                  <option value="+82">KR +82</option>
                  <option value="+971">AE +971</option>
                  <option value="+61">AU +61</option>
                  <option value="+64">NZ +64</option>
                </select>
                <input type="tel" id="notify_phone" class="notify-phone-input" placeholder="Mobile number" autocomplete="tel-national" />
              </div>

              <!-- Consent copy is placeholder pending legal review for AU/NZ Spam Act + international markets -->
              <div class="notify-checkbox notify-checkbox--sms">
                <input type="checkbox" id="notify_sms_consent" name="sms_consent" />
                <label for="notify_sms_consent">Send me SMS restock alerts. Message and data rates may apply. Reply STOP to unsubscribe.</label>
              </div>
            </div>
            <div class="notify-divider"></div>
          </div>
          <div class="notify-form-message" style="display:none; margin-top: 1em;"></div>
            <div class="back-in-stock-form__submit">
              <button class="notify-submit button">SUBMIT</button>
            </div>
            <p class="notify-privacy">
              <small>By clicking “Submit” you agree to our 
              <a href="/pages/privacy-policy" target="_blank">privacy policy</a></small>
            </p>
                    
        </div>
      </div>
      <div class="custom-filter-drawer__overlay drawer__overlay"></div>
    </div>
  `;

  document.body.appendChild(modal);
  requestAnimationFrame(() => modal.classList.add('open'));

  // Clear the SMS consent error highlight as soon as the user ticks the box.
  modal.querySelector('#notify_sms_consent')?.addEventListener('change', (e) => {
    if (e.target.checked) {
      modal.querySelector('.notify-checkbox--sms')?.classList.remove('notify-checkbox--error');
    }
  });

  // Clear the email error highlight as soon as the user starts typing.
  modal.querySelector('#notify_email')?.addEventListener('input', (e) => {
    if (e.target.value.trim()) {
      e.target.classList.remove('notify-input--error');
    }
  });

  // Default the country code dropdown to the visitor's market when possible.
  // Shopify exposes the visitor's country as Shopify.country (ISO 3166-1 alpha-2).
  (function defaultCountryFromShopify() {
    const select = modal.querySelector('#notify_phone_country');
    if (!select) return;
    const iso = (window.Shopify && window.Shopify.country) ? String(window.Shopify.country).toUpperCase() : null;
    if (!iso) return;
    // Map ISO country codes to the option values used in the dropdown above.
    const map = {
      GB: '+44', UK: '+44',
      US: '+1-us', CA: '+1-ca',
      FR: '+33', DE: '+49', IT: '+39', ES: '+34', NL: '+31',
      BE: '+32', CH: '+41', AT: '+43', DK: '+45', SE: '+46', NO: '+47',
      IE: '+353', PT: '+351',
      JP: '+81', HK: '+852', SG: '+65', KR: '+82', AE: '+971',
      AU: '+61', NZ: '+64'
    };
    const target = map[iso];
    if (target && Array.from(select.options).some(o => o.value === target)) {
      select.value = target;
    }
  })();

  //modal.querySelector('.notify-close').addEventListener('click', () => modal.remove());
  //modal.querySelectorAll('.notify-close, .custom-filter-drawer__overlay').forEach(el => {
  //  el.addEventListener('click', () => modal.remove());
  //});

  function clearVariantParamFromUrl() {
    const url = new URL(window.location.href);
    url.searchParams.delete('variant'); // remove ?variant=...
    // Preserve other params + hash if any
    window.history.replaceState({}, '', url.toString());
  }


  modal.querySelectorAll('.notify-close, .custom-filter-drawer__overlay').forEach(el => {
    el.addEventListener('click', () => {
      clearNotifySelection();
      clearVariantParamFromUrl();
      modal.remove();
    });
  }); 


  let selectedVariantId = null;

  // Priority 1: Use clicked variant ID if available
  if (clickedVariantId) {
    selectedVariantId = clickedVariantId;
  }
  // Priority 2: If no clicked variant and only one OOS variant, use that
  else if (outOfStockVariants.length === 1) {
    selectedVariantId = String(outOfStockVariants[0].id);
  }

  // Auto-preselect button if we have a selectedVariantId and size grid exists
  if (selectedVariantId && outOfStockVariants.length > 1) {
    let btnToSelect = modal.querySelector(`.size-box[data-variant-id="${selectedVariantId}"]`);

    if (!btnToSelect) {
      // Fallback: match by button text
      btnToSelect = Array.from(modal.querySelectorAll('.size-box')).find(button =>
        button.textContent.trim() === selectedVariantId
      );
    }

    if (btnToSelect) {
      // Remove 'selected' from all buttons first
      modal.querySelectorAll('.size-box.selected').forEach(btn => {
        btn.classList.remove('selected');
      });

      btnToSelect.classList.add('selected');
    }
  }


  modal.querySelectorAll('.size-box').forEach(button => {
    button.addEventListener('click', () => {
      modal.querySelectorAll('.size-box').forEach(b => b.classList.remove('selected'));
      button.classList.add('selected');
      selectedVariantId = button.dataset.variantId;
      console.log('variantID', selectedVariantId);
    });
  });

  /*if (clickedVariantId) {
    const btnToSelect = modal.querySelector(`.size-box[data-variant-id="${clickedVariantId}"]`);
    if (btnToSelect) {
      btnToSelect.classList.add('selected');
      selectedVariantId = clickedVariantId;
    }
  }*/

  modal.querySelector('.notify-submit').addEventListener('click', (e) => {
    e.preventDefault();

    const modal = e.target.closest('#notify-modal'); // 🔥 ENSURE modal is correctly referenced
    if (!modal) return;

    const email = (modal.querySelector('#notify_email').value || '').trim();
    const agreed = modal.querySelector('#customer_accepts_marketing').checked;
    const phoneRaw = (modal.querySelector('#notify_phone')?.value || '').trim();
    // Country select values may include disambiguation suffix for shared dial codes
    // (e.g. "+1-us" / "+1-ca" so the dropdown can list both). Strip it for E.164.
    const countryCodeRaw = modal.querySelector('#notify_phone_country')?.value || '+44';
    const countryCode = countryCodeRaw.replace(/-.*$/, '');
    const smsConsent = modal.querySelector('#notify_sms_consent')?.checked || false;

    const messageBox = modal.querySelector('.notify-form-message');
    const notifyPrivacy = modal.querySelector('.notify-privacy');
    messageBox.style.display = 'block';

    if (outOfStockVariants.length > 1 && !selectedVariantId) {
      messageBox.innerHTML = '<p class="error-message">Please select a size.</p>';
      messageBox.style.display = 'block';
      return;
    }
    const emailInput = modal.querySelector('#notify_email');
    if (!email) {
      emailInput?.classList.add('notify-input--error');
      emailInput?.focus();
      messageBox.innerHTML = '';
      messageBox.style.display = 'none';
      return;
    }
    emailInput?.classList.remove('notify-input--error');

    // Phone is optional. To submit a phone, user must also tick SMS consent (legally required).
    let phone = null;
    const smsCheckboxWrap = modal.querySelector('.notify-checkbox--sms');
    if (phoneRaw) {
      if (!smsConsent) {
        // Visually flag the SMS consent row instead of showing a redundant message.
        smsCheckboxWrap?.classList.add('notify-checkbox--error');
        messageBox.innerHTML = '';
        messageBox.style.display = 'none';
        return;
      }
      smsCheckboxWrap?.classList.remove('notify-checkbox--error');
      const digits = phoneRaw.replace(/\D/g, '').replace(/^0+/, '');
      const candidate = countryCode + digits;
      if (!/^\+[1-9]\d{7,14}$/.test(candidate)) {
        messageBox.innerHTML = '<p class="error-message">Please enter a valid mobile number, or leave empty to skip SMS alerts.</p>';
        messageBox.style.display = 'block';
        return;
      }
      phone = candidate;
    }



    //const productId = {{ product.id | json }};
    const productId = parent?.dataset.productId;
    const productHandle = parent?.dataset.productHandle;


    const variantId = selectedVariantId;
    const selectedVariant = variantOptions.find(v => v.id == selectedVariantId);
    const selectedSKU = selectedVariant?.sku || '';
    const selectedPrice = selectedVariant?.price || '';
    const productData = document.querySelector('quick-add-component');      

    console.log('productId:', productId, 'variantId:', variantId, 'selectedVariant:', selectedVariant, 'selectedSKU:', selectedSKU, 'selectedPrice:', selectedPrice );

    const notificationCallback = function(data) {
      console.log("BIS response:", data); // For debugging
      if (!modal) return;
      if (data.status == 'OK') {
        console.log('Back in Stock notification succeeded:', data.message);

        if (notifyPrivacy) {
          notifyPrivacy.style.display = 'none';
        }

        const oldBtn = modal.querySelector('.notify-submit');
        if (oldBtn) {
          const closeBtn = oldBtn.cloneNode(true);
          closeBtn.textContent = "Close";
          oldBtn.replaceWith(closeBtn);

          closeBtn.addEventListener('click', () => {
            clearNotifySelection();
            clearVariantParamFromUrl();
            modal.remove();            
          });
        }

        const messageBox = modal.querySelector('.notify-form-message');

        if (messageBox) {
          messageBox.innerHTML = `<p class="success-message">You’re on the waitlist! We will notify you when the item becomes available.</p> <p>&nbsp;</p><div class="notify-divider"></div>`;
          messageBox.style.display = 'block';
        }

        // Optionally hide the form or size selection after success
        const notifySet1 = modal.querySelector('.notify-set1');
        if (notifySet1) notifySet1.style.display = 'none';

        const submitBtn = modal.querySelector('.notify-submit');
        if (submitBtn) submitBtn.style.display = 'none';


      } else if (data?.errors) {
        let msg = '';
        for (const k in data.errors) {
          msg += `${k}: ${data.errors[k].join(', ')}\n`;
        }
        alert(msg);
      } else {
        alert("Unexpected response from the server.");
        console.warn("Unexpected BIS response:", data);
      }
    };

    if (typeof window.bisSubmit !== 'function') {
      alert("Notification service unavailable. Please try again later.");
      console.error("bisSubmit not available — klaviyo-bis.js failed to load");
      return;
    }

    window.bisSubmit({
      email: email,
      phone: phone,
      variantId: variantId,
      productId: productId,
      handle: productHandle,
      sku: selectedSKU,
      price: selectedPrice,
      emailConsent: agreed,
      smsConsent: smsConsent
    }, function(err, result) {
      console.log("BIS callback triggered");
      if (err) {
        if (messageBox) {
          messageBox.innerHTML = '<p class="error-message">' + (err.message || 'There was an error submitting the notification.') + '</p>';
          messageBox.style.display = 'block';
        } else {
          alert(err.message || "There was an error submitting the notification.");
        }
        console.error("BIS error:", err);
        return;
      }
      notificationCallback(result);
    });
    console.log("BIS payload:", {
      email, phone, variantId, productId,
      handle: productHandle,
      sku: selectedSKU,
      price: selectedPrice,
      emailConsent: agreed,
      smsConsent: smsConsent
    });

  });
});